const form = {
  formId: "new-user-form",
  formField: {
    invoiceSymbol: {
      name: "invoiceSymbol",
      label: "Mẫu số",
      type: "text",
      placeholder: "A1B2C3",
      errorMsg: "Vui lòng nhập mẫu số",
    },
    invoiceSample: {
      name: "invoiceSample",
      label: "Ký hiệu",
      type: "text",
      placeholder: "A1B2C3",
      errorMsg: "Vui lòng nhập ký hiệu",
    },
    supplierName: {
      name: "supplierName",
      label: "Doanh nghiệp in/Doanh nghiệp cung cấp phần mềm",
      type: "text",
      placeholder: "Tên nhà cung cấp",
      errorMsg: "Vui lòng nhập tên Doanh nghiệp in/Doanh nghiệp cung cấp phần mềm",
    },
    supplierTaxCode: {
      name: "supplierTaxCode",
      label: "MST",
      type: "text",
      placeholder: "Mã số thuế nhà cung cấp",
      errorMsg: "Vui lòng nhập MST",
    },
    numberOfRegistrations: {
      name: "numberOfRegistrations",
      label: "Số lượng",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập số lượng",
    },
    name: {
      name: "name",
      label: "Tên hóa đơn",
      type: "text",
      placeholder: "Nhập tên hóa đơn",
      errorMsg: "Vui lòng nhập tên hóa đơn",
    },
    from: {
      name: "from",
      label: "Từ số",
      type: "number",
      placeholder: "1",
      errorMsg: "Vui lòng nhập số bắt đầu",
    },
    to: {
      name: "to",
      label: "Đến số",
      type: "number",
      placeholder: "100",
      errorMsg: "Vui lòng nhập số kết thúc",
    },
    dayActive: {
      name: "dayActive",
      label: "Ngày bắt đầu sử dụng",
      type: "text",
      placeholder: "1/1/2026",
      errorMsg: "Vui lòng nhập ngày bắt đầu sử dụng",
    },
    status: {
      name: "status",
      label: "Trạng thái",
      type: "text",
      placeholder: "Chọn",
      // errorMsg: "Vui lòng nhập số người đăng ký",
    },
    used: {
      name: "used",
      label: "Đã sử dụng",
      type: "text",
      placeholder: "",
      // errorMsg: "Vui lòng nhập số người đăng ký",
    },
  },
};

export default form;
